import React, { useState, useMemo } from "react";
import { PermissionsEnum } from "@/auth/interfaces";
import { SingleTableBoxScene,  GeneralTable } from "@/shared/components/ui";
import { MRT_ColumnDef } from "material-react-table";
import { useTableFilter, useCheckPermissions } from "@/shared";
import { hasPermission} from "@/shared";
import { useFetchMisSolicitudes, SolicitudPreventaRow } from "@/shared/actions/erp/solicitudpreventacoorporativo/solicitur-preventa-corporativo.actions";
import ModalComentariosSolicitud from "../../shared/ModalComentariosSolicitud";
import { getEstadoConfig, getComplejidadConfig, chipStyle } from "../../shared/estado-solicitud";
import { formatDateWithTime } from "@/shared";
import VisibilityIcon from '@mui/icons-material/Visibility';


export interface SolicitudPageInterface {}

const SolicitudPreventa: React.FC<SolicitudPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_solicitudcorporativa);
  
  const {  pagination, setPagination } = useTableFilter();
  const {pageIndex, pageSize} = pagination;
  const { data:response, isLoading, isFetching } = useFetchMisSolicitudes({
    params: {page: pageIndex +1, page_size: pageSize}
  });

  const [openModal, setOpenModal] = useState(false);
  const [selectedSolicitudId, setSelectedSolicitudId] = useState<string | undefined>(undefined);


  const tableData: SolicitudPreventaRow[] = useMemo(() => {
  if (!response?.data?.data) return [];
  return response?.data?.data?.map((solicitud: any) => {
    const clientes = solicitud?.clientes || [];

    const sucursales = clientes.flatMap((cliente: any) => cliente.sucursales || []);

    return {
      id_solicitud: solicitud?.id_solicitud_corporatavia,
      codigo: solicitud?.codigo || "—",

      nombre_cliente:
        clientes.length > 0
          ? clientes.map((c: any) => c?.cliente_oficina).join(", ")
          : "Sin Clientes",

      nombre_sucursal:
        sucursales.length > 0
          ? sucursales.map((s: any) => s?.nombre_sucursal).join(", ")
          : "Sin sucursales",

      velocidad_kbps:
        sucursales.length > 0
          ? sucursales.map((s: any) => s?.velocidad).join(", ")
          : "0",

      servicio:
        sucursales.length > 0
          ? sucursales.map((s: any) => s?.servicio).join(", ")
          : "-",

      coordenadas:
        sucursales.length > 0
          ? sucursales.map((s: any) => s?.coordenadas).join(" | ")
          : "-",

      comentarios_permisos: solicitud?.comentario_general || "",

      estado_solicitud: solicitud?.estado_solicitud || "-",
      complejidad: solicitud?.complejidad || "",
      fecha_creacion: solicitud?.fecha_creacion || "",
      fecha_gestion: solicitud?.fecha_gestion || "",
    };
  });
}, [response]);



  // Columnas de la tabla
  const columns = useMemo<MRT_ColumnDef<SolicitudPreventaRow>[]>(
    () => [
    {
      accessorKey: "codigo",
      header: "ID Único",
      size: 150,
      Cell: ({ row }) => (
        <span style={{ fontWeight: 600, fontFamily: 'monospace' }}>
          {row.original?.codigo || "—"}
        </span>
      ),
    },
    {
      accessorKey: "nombre_cliente",
      header: "Cliente",
      size: 200,
      Cell: ({ row }) => row.original?.nombre_cliente?.trim() || "—",
    },
    {
      accessorKey: "fecha_creacion",
      header: "Fecha de Registro",
      size: 170,
      Cell: ({ row }) =>
        row.original?.fecha_creacion ? formatDateWithTime(row.original.fecha_creacion) : "—",
    },
    {
      accessorKey: "fecha_gestion",
      header: "Fecha de Aprobación",
      size: 170,
      Cell: ({ row }) =>
        row.original?.fecha_gestion ? formatDateWithTime(row.original.fecha_gestion) : "—",
    },
    {
      accessorKey: "estado_solicitud",
      header: "Estado",
      size: 150,
      Cell: ({ row }) => {
        const cfg = getEstadoConfig(row.original.estado_solicitud);
        return <span style={chipStyle(cfg)}>{cfg.label.toUpperCase()}</span>;
      },
    },
    {
      accessorKey: "complejidad",
      header: "Complejidad",
      size: 130,
      Cell: ({ row }) => {
        const cfg = getComplejidadConfig(row.original.complejidad);
        return cfg
          ? <span style={chipStyle(cfg)}>{cfg.label.toUpperCase()}</span>
          : <span style={{ color: '#9e9e9e' }}>—</span>;
      },
    },
  ], []);

  // Función para abrir el modal con la solicitud seleccionada
  const handleVerSolicitud = (id: string) => {
    setSelectedSolicitudId(id);
    setOpenModal(true);
  };

  return (
    <SingleTableBoxScene 
    title="Solicitud Preventa" 
    urlRedirect="crear" 
    enableRedirect={hasPermission(PermissionsEnum.api_add_solicitudcorporativa)}
    
    >
      {/* <CustomSearch 
      onChange={onChangeFilter} 
      value={globalFilter} 
      text="Buscar sucursal..." 
      cleanFilter={cleanFilter} /> */}
      {Array.isArray(tableData) && tableData.length >0 && (
        <GeneralTable<SolicitudPreventaRow>
          columns={columns}
          data={Array.isArray(tableData) ? tableData : []}
          //
          isLoading={isLoading}
          isRefetching={isFetching}
          //
          enableGlobalFilter={false}
          //
          enableManualFiltering={false}
          enableColumnFilters={false}
        
          pagination={pagination}
          onPaging={setPagination}
          rowCount={response?.data?.count ?? 0}


          onEdit={(row) => handleVerSolicitud(row.id_solicitud)}
          editIcon={<VisibilityIcon/>}
          editIconColor="info"
          toolTipTitleEditIcon="Ver detalles"
          
        />
      )}

      {/* Modal de detalles de la solicitud */}
      <ModalComentariosSolicitud
        open={openModal}
        setOpen={setOpenModal}
        solicitud={selectedSolicitudId}
      />
    </SingleTableBoxScene>
  );
};


export default SolicitudPreventa;